import React, { Fragment, Component } from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { ModalNews } from './Modal/ModalNews';
import { ModalConsole } from './Modal/ModalConsole';
import { CarouselOperation } from './Carousel/CarouselOperation';
import { ModalAlarmes } from './Modal/ModalAlarmes';
import { ModalIndicateur } from './Modal/ModalIndicateur';/* YD : 20230407 : 2240 */

import logoEiffage from '../images/logo-eiffage-immobilier.png';
import fondPied from '../images/fond-Pied.png';

import './Home.css';
import '../css/immocom.css';

export class Home extends Component {

    render = () => {
        return <Fragment>
            <Stack verticalFill className="divHome">
                <Stack.Item align="baseline">
                    <img src={logoEiffage} alt="Eiffage Immobilier" className="logoEiffageHome" />
                </Stack.Item>
                <Stack.Item align="center" grow className="divContainerCarousel">
                    <CarouselOperation avecLegende />
                </Stack.Item>
                <Stack.Item align="end">
                    <img src={fondPied} alt="Pied de page" className="imagePiedPage" />
                </Stack.Item>
            </Stack>
            <ModalNews />
            <ModalConsole />
            <ModalAlarmes />
            <ModalIndicateur />
        </Fragment>;
    };

}
